/* @ngInject */

export default ($rootScope, helperService, helperPdfService, Address) => {
  /**
   * Prepare asset finance asset to be financed.
   *
   * @param {Array} assetDetails
   * @param {String} pageBreak
   * @param {Boolean} isQuickTool
   *
   * @returns {Array}
   */
  const prepareAssetFinanceAssetToBeFinancedDetails = ({
    assetDetails,
    additionalProduct,
    pageBreak,
    isQuickTool
  }) => {
    const content = [];
    if (assetDetails?.length) {
      if (!pageBreak) {
        content.push({
          text: '',
          margin: [0, 20, 0, 0]
        });
      }
      content.push(
        helperPdfService.createHeader({
          title: 'ASSET TO BE FINANCED',
          pageBreak: pageBreak || ''
        })
      );
      const len = assetDetails.length;
      for (let a = 0; a < len; a += 1) {
        const assetDetail = assetDetails[a];
        content.push(
          helperPdfService.createSubHeader({ title: `ASSET TO BE FINANCED #${a + 1}` })
        );
        content.push({
          table: {
            widths: ['25%', '25%', '25%', '25%'],
            body: [
              [
                {
                  text: [
                    { text: 'Asset type\n', style: 'label' },
                    {
                      text: helperService.getAssetFinanceAssetType(assetDetail?.type),
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    {
                      text: 'Asset age\n',
                      style: 'label'
                    },
                    {
                      text: helperService.getAssetFinanceAssetAge(assetDetail?.age),
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    { text: 'Model\n', style: 'label' },
                    {
                      text: assetDetail?.vehicle?.model || '-',
                      style: 'value'
                    }
                  ],
                  colSpan: 2
                },
                ''
              ],
              [
                {
                  text: [
                    { text: 'Asset cost\n', style: 'label' },
                    {
                      text: helperService
                        .isNumber(assetDetail?.cost, true)
                        .formatWithCurrency($rootScope.CurrentCurrency(), 2),
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    { text: 'Deposit paid\n', style: 'label' },
                    {
                      text: helperService
                        .isNumber(assetDetail?.deposit, true)
                        .formatWithCurrency($rootScope.CurrentCurrency(), 2),
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    { text: 'Net trade in contribution\n', style: 'label' },
                    {
                      text: helperService
                        .isNumber(
                          !assetDetail?.isTradeEquityApplied ? assetDetail?.trade?.balance : 0,
                          true
                        )
                        .formatWithCurrency($rootScope.CurrentCurrency(), 2),
                      style: 'value'
                    }
                  ]
                },
                {
                  text: [
                    { text: 'Net cost\n', style: 'label' },
                    {
                      text: helperService
                        .isNumber(assetDetail?.netCost, true)
                        .formatWithCurrency($rootScope.CurrentCurrency(), 2),
                      style: 'value'
                    }
                  ]
                }
              ]
            ]
          },
          layout: 'noBorders'
        });
        if (additionalProduct) {
          content.push(helperPdfService.createSubHeader({ title: 'ADDITIONAL PRODUCT' }));
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Provider name\n', style: 'label' },
                      {
                        text: additionalProduct?.name || '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Product description\n', style: 'label' },
                      {
                        text: additionalProduct?.policyNumber || '-',
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Premium amount\n', style: 'label' },
                      {
                        text: helperService
                          .isNumber(additionalProduct?.premiumAmount, true)
                          .formatWithCurrency($rootScope.CurrentCurrency(), 2),
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Capitalise\n', style: 'label' },
                      {
                        text: additionalProduct?.isCapitalized ? 'Yes' : 'No',
                        style: 'value'
                      }
                    ]
                  }
                ]
              ]
            },
            layout: 'noBorders'
          });
        }
        if (assetDetail?.vendor?.type) {
          if (isQuickTool) {
            content.push({
              table: {
                widths: ['25%', '25%', '25%', '25%'],
                body: [
                  [
                    {
                      text: [
                        { text: 'Vendor type\n', style: 'label' },
                        {
                          text: helperService.getAssetFinanceVendorType(
                            assetDetail?.vendor?.type
                          ),
                          style: 'value'
                        }
                      ]
                    },
                    '',
                    '',
                    ''
                  ]
                ]
              },
              layout: 'noBorders'
            });
          } else {
            content.push(helperPdfService.createSubHeader({ title: `VENDOR #${a + 1}` }));
            content.push({
              table: {
                widths: ['25%', '25%', '25%', '25%'],
                body: [
                  [
                    {
                      text: [
                        { text: 'Vendor type\n', style: 'label' },
                        {
                          text: helperService.getAssetFinanceVendorType(
                            assetDetail?.vendor?.type
                          ),
                          style: 'value'
                        }
                      ]
                    },
                    {
                      text: [
                        { text: 'Vendor name\n', style: 'label' },
                        {
                          text: assetDetail?.vendor?.name || '-',
                          style: 'value'
                        }
                      ]
                    },
                    {
                      text: [
                        { text: 'Phone\n', style: 'label' },
                        {
                          text: `${
                            assetDetail?.vendor?.phone ? assetDetail?.vendor?.phoneCode : ''
                          } ${assetDetail?.vendor?.phone || '-'}`,
                          style: 'value'
                        }
                      ]
                    },
                    {
                      text: [
                        { text: 'FAX\n', style: 'label' },
                        {
                          text: `${
                            assetDetail?.vendor?.fax ? assetDetail?.vendor?.faxCode : ''
                          } ${assetDetail?.vendor?.fax || '-'}`,
                          style: 'value'
                        }
                      ]
                    }
                  ],
                  [
                    {
                      text: [
                        { text: 'E-Mail\n', style: 'label' },
                        {
                          text: assetDetail?.vendor?.email || '-',
                          style: 'value'
                        }
                      ],
                      colSpan: 2
                    },
                    '',
                    {
                      text: [
                        { text: 'Contact first name\n', style: 'label' },
                        {
                          text: assetDetail?.vendor?.contactFirstName || '-',
                          style: 'value'
                        }
                      ]
                    },
                    {
                      text: [
                        { text: 'Contact surname\n', style: 'label' },
                        {
                          text: assetDetail?.vendor?.contactSurname || '-',
                          style: 'value'
                        }
                      ]
                    }
                  ],
                  [
                    {
                      text: [
                        { text: 'Vendor address\n', style: 'label' },
                        {
                          text: Address.getAddress(assetDetail?.vendor?.address),
                          style: 'value'
                        }
                      ],
                      colSpan: 2
                    },
                    '',
                    '',
                    ''
                  ]
                ]
              },
              layout: 'noBorders'
            });
          }
        }
      }
    }
    return content;
  };

  return {
    prepareAssetFinanceAssetToBeFinancedDetails
  };
};
